<template>
    <div class="region-panel">
        <div class="region-title font-color">地域归属</div>
        <div class="region-info-bar">
            <div class="text">地块总面积:</div>
            <div class="number font-color">{{`${totalArea} ${infoData[0]&&infoData[0].unit}`}}</div>
        </div>
        <div class="region-info-bar" v-for="(item,index) in infoData" :key="index">
            <div class="circle" :style="{background: item.color}"></div>
            <div class="text">{{item.key}}</div>
            <div class="number font-color">{{`${$common.thousandBitSeparator(item.value)} ${item.unit}`}}</div>
        </div>
        <div class="legend">图例</div>
        <div class="region-info-bar">
            <img src="../../assets/images/digital/region-legend-1.png" />
            <div class="legend-text font-color">本期建设红线</div>
        </div>
        <div class="region-info-bar">
            <img src="../../assets/images/digital/region-legend-2.png" />
            <div class="legend-text font-color">省界</div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "Region",
    data() {
        return {
            infoData: []
        }
    },
    created() {
        this.getDataAxios()
    },
    computed: {
        totalArea() {
            let total = 0
            for(let i=0;i<this.infoData.length;i++) {
                total += parseFloat(this.infoData[i].value)
            }
            return this.$common.thousandBitSeparator(total)
        }
    },
    methods: {
        ...mapActions('gisData', ['setGisSchemeAsync']),
        //获取地域信息
        getDataAxios() {
            let _this = this;
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/region`
            this.$common.getTokenRequest()
            .get(url)
            .then(res => {
              if (res.status === 200) {
                let data = res.data;
                if(data.code === 0) {
                    _this.infoData = data.data;
                    let sheme = {
                        field: 'BLK',
                        colorInfo: {}
                    }
                    for(let item of data.data) {
                        for(let lot of item.lots) {
                            sheme.colorInfo[lot] = item.color
                        }
                    }
                    _this.setGisSchemeAsync(sheme)
                }
              }
            }).catch(err=>{
              console.log(err,'===/v1/digital/region')
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.region-panel {
    width: 100%;
    .region-title {
        font-size: 16px;
        font-family: SourceHanSansCN-Heavy;
        font-weight: 800;
        margin-bottom: 20px;
    }
    .region-info-bar {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: #fff;
        margin: 10px 0;
        .circle {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 14px;
        }
        .text {
            width: 100px;
            word-wrap: break-word;
        }
        .number {
            flex: 1;
            text-align: right;
        }
        .legend-text {
            flex: 1;
            text-align: right;
            font-size: 16px;
            font-family: SourceHanSansCN-Heavy;
            font-weight: 800;
        }
        :last-child {
            margin-bottom: 10px;
        }
    }
    .legend {
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        color: #fff;
        margin: 30px 0 20px 0;
    }
}
</style>